import React from "react";

import styles from "./SearchPopover.module.scss";

const SearchPopover = React.forwardRef(
  ({ criteria, onAdd, options, searchText, visible: isVisible }, ref) => (
    <ul className={`${styles.base} ${isVisible ? styles.open : ""}`} ref={ref}>
      {options
        .filter(({ key }) =>
          criteria ? criteria.map(item => item.key).indexOf(key) === -1 : true
        )
        .filter(({ regex }) => regex.test(searchText))
        .map(option => (
          <li
            data-option
            key={option.key}
            onClick={() => onAdd(option)}
            onKeyDown={event => {
              const { key, currentTarget } = event;
              const next = key === "ArrowDown";
              const prev = key === "ArrowUp";

              if (!next && !prev) return;

              event.preventDefault();

              const nextFocus =
                currentTarget[
                  next ? "nextElementSibling" : "previousElementSibling"
                ];

              if (nextFocus) nextFocus.focus();
            }}
            onKeyPress={({ key }) => key === "Enter" && onAdd(option)}
            tabIndex={-1}
          >
            <span>{searchText}</span> in <b>{option.label}</b>
          </li>
        ))}
    </ul>
  )
);

export default SearchPopover;
